import React, { useState, useEffect, useRef } from 'react';
import { Button, Container, Row, Col, Tabs, Tab } from "react-bootstrap";

import { Switch, Route, useHistory, useRouteMatch, useLocation, useParams } from 'react-router-dom';
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import { userActions, resourceActions, templateActions, } from '../../actions';
import { useTranslation } from 'react-i18next';
import PageTitle from "../../components/common/PageTitle";
import AuthImage from "../../components/common/AuthImage";
import yup from "yup";
// import Dropzone from "react-dropzone";
import { useDropzone } from 'react-dropzone';
import { useFormik } from 'formik';
import CheckPermission from '../../components/checkPermission/CheckPermission'
import AddResource from '../../components/resource/AddResource';

import { _getCategories } from './categoriesSize';
import { authResourceUrl } from '../../utils/authResourceUrl';

const TemplateEdit = () => {

  const history = useHistory();
  const dispatch = useDispatch();
  const { _templateId } = useParams();
  const { t } = useTranslation();
  // const user = useSelector(state => state.authentication.user);
  const location = useLocation();
  const { path, url } = useRouteMatch();
  const loading = useSelector(state => state.template.status);
  const resourceLoading = useSelector(state => state.resource.loading);
  const deleteResult = useSelector(state => state.resource.deleteResult);
  const template = useSelector(state => state.template.template);
  const uploadProgress = useSelector(state => state.resource.uploadProgress);
  const userImages = useSelector(state => state.resource.userImages);
  const userVideos = useSelector(state => state.resource.userVideos);
  const userToken = useSelector(state => state.authentication.user.authToken);
  const tempImages = useSelector(state => state.resource.images);
  const tempVideos = useSelector(state => state.resource.videos);
  const tempElements = useSelector(state => state.resource.elements);
  const group = useSelector(state => state.authentication.user.group);
  const [initialValues, setInitialValues] = useState({ name: '' })
  const [sendUpdate, setSendUpdate] = useState(0)
  const [activeTab, setActiveTab] = useState()
  const [deleteID, setDeleteID] = useState(null)
  const [deleteSuccess, setDeleteSuccess] = useState(null)
  const fileInputRef = useRef();
  const uploadFormRef = useRef();
  const userImageList = useRef([]);
  const categoriesSize = _getCategories();
  const [allowedCategories, setAllowedCategories] = useState([])
  const [templateCategory, setTemplateCategory] = useState('')
  const authToken = useSelector(state => state.authentication.user?.authToken);

  // DropZone
  const [files, setFiles] = useState([]);
  let reader = new FileReader();
  const { getRootProps, getInputProps } = useDropzone({
    accept: 'image/*',
    onDrop: acceptedFiles => {
      uploadFormik.values.files = (acceptedFiles)
    }
  });

  const thumbs = files.map(file => {
    return (
      <div className="thumb" key={file.name}>
        <div className="thumbInner">
          <img
            src={file.preview}
            className="img"
          />
        </div>
        <span>{file.name}</span>
      </div>
    )
  });

  useEffect(() => {
    dispatch(
      templateActions.getById(_templateId),
    );
  }, [])

  // useEffect(() => {
  //   dispatch(resourceActions.resetState());
  //   dispatch(
  //     resourceActions.search({ type: 'Image', tempId: parseInt(template.tempId) }),
  //   );
  // }, [userImages])
  // useEffect(() => {
  //   dispatch(resourceActions.resetState());
  //   dispatch(
  //     resourceActions.search({ type: 'Video', tempId: parseInt(template.tempId) }),
  //   );
  // }, [userVideos])

  const getResources = () => {
    if (activeTab !== 'resources') return;
    dispatch(resourceActions.resetState());
    
    const searchParams = { type: 'Image' };
    if (template.tempId && !isNaN(parseInt(template.tempId))) {
        searchParams.tempId = parseInt(template.tempId);
    }
    
    dispatch(resourceActions.search(searchParams));
    
    // برای Video
    const videoParams = { type: 'Video' };
    if (template.tempId && !isNaN(parseInt(template.tempId))) {
        videoParams.tempId = parseInt(template.tempId);
    }
    dispatch(resourceActions.search(videoParams));
    
    // برای Element
    const elementParams = { type: 'Element' };
    if (template.tempId && !isNaN(parseInt(template.tempId))) {
        elementParams.tempId = parseInt(template.tempId);
    }
    dispatch(resourceActions.search(elementParams));
  }
  useEffect(() => {
    getResources();
  }, [activeTab])

  useEffect(() => {
    if (deleteResult === "success"){
      setDeleteSuccess("File delete successfully.");
      getResources();
    }else if(deleteResult === "failed"){
      setDeleteSuccess("File deletion failed.");
    }
  }, [deleteResult])

  // useEffect(() => {
  //   if (activeTab !== 100) return;
  //   dispatch(resourceActions.resetState());
  //   dispatch(
  //     resourceActions.search({ type: 'Image', tempId: parseInt(template.tempId) }),
  //   );
  //   dispatch(
  //     resourceActions.search({ type: 'Video', tempId: parseInt(template.tempId) }),
  //   );
  //   dispatch(
  //     resourceActions.search({ type: 'Element', tempId: parseInt(template.tempId) }),
  //   );

  // }, [uploadProgress])


  useEffect(() => () => {
    // Make sure to revoke the data uris to avoid memory leaks
    files.forEach(file => URL.revokeObjectURL(file.preview));
  }, [files]);

  // DropZone End


  useEffect(() => {
    if (sendUpdate === 1 && loading === 'success') {
      setSendUpdate(2)
    } else if (sendUpdate === 1 && loading === 'failure') {
      setSendUpdate(-1)
    }
  }, [loading])


  useEffect(() => {
    setInitialValues({})
    formik.values.name = template.name;
    formik.values.price = _.get(template, 'price', '0');
    formik.values.description = _.get(template, 'description', '');
    formik.values.categories = _.get(template, 'categories', '');
    formik.values.tags = _.get(template, 'tags', '');
    formik.values.tagsFa = _.get(template, 'tagsFa', '');
    formik.values.invisible = _.get(template, 'invisible', false).toString();
    setTemplateCategory(_.get(template, 'categories[0]'))

    const templateSize = `${_.get(template, 'size.width')}x${_.get(template, 'size.height')}`
    const categories = []
    categoriesSize.map(category => {
      if (templateSize === category.size) categories.push(category)
    })
    setAllowedCategories(categories);
  }, [template])

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: values => {
      setSendUpdate(1);
      let tags, tagsFa;
      if (typeof values.tags === 'string') {
        tags = values.tags.split(",");
      } else {
        tags = values.tags;
      }
      if (typeof values.tagsFa === 'string') {
        const newTagsFa = values.tagsFa.replace(/،/g, ",")
        tagsFa = newTagsFa.split(",");
      } else {
        tagsFa = values.tagsFa;
      }
      dispatch(
        templateActions.update(_templateId, {
          name: values.name,
          price: values.price,
          categories: [templateCategory],
          invisible: values.invisible,
          description: values.description,
          tagsFa: tagsFa,
          tags: tags,
        }),
      );
    },

  });

  const uploadFormik = useFormik({
    initialValues: {
      files: [],
    },
    onSubmit: values => {
      const files = [];
      values.files.map(file => {
        let form_data = new FormData();
        const tempFile = {
          path: file.path,
          name: file.name,
          size: file.size,
          type: file.type,
          invisible: true,
        }
        for (var key in tempFile) {
          form_data.append(key, tempFile[key]);
        }
        files.push(tempFile);
      })
      dispatch(
        resourceActions.upload(files),
      );
    },

  });

  const fileChange = event => {
    if (event.target.files[0].type.includes('image')) {
      userImageList.current.push({
        src: `${process.env.REACT_APP_FILE_SERVER}/resources/images/thumbnail.png`,
        width: 150,
        height: 150,
        key: 'unknown',
        type: 'Uploading',
        data: {
          id: 'unknown',
        },
      });
      // setUploadTabActiveIndex(0);
    } else {
      userImageList.current.push({
        src: `${process.env.REACT_APP_FILE_SERVER}/resources/videos/thumbnail.png`,
        width: 150,
        height: 150,
        key: 'unknown',
        type: 'Uploading',
        data: {
          id: 'unknown',
        },
      });
      //   setUploadTabActiveIndex(1);
    }
    // uploadFormRef.current.submit();
    const formData = new FormData(uploadFormRef.current);
    const files = formData.get('files');
    const fileType = files.type.split('/')[0];
    const params = {
      // group: template.group,
      type: _.startCase(fileType),
      // tempId: template.tempId,
    }
    for (var pair of formData.entries()) {
    }
    // dispatch(resourceActions.upload([...event.target.files]));
    dispatch(resourceActions.upload(formData, params));
  };

  const uploadFormHandle = (event) => {

  }
  const deleteHandler = (delObj) => {
    setDeleteID(null);
    dispatch(
      resourceActions.deleteResource(delObj.type, delObj.id),
    );
  }
  const designHandler = (_id, tempId) => {
    // history.push(`template/${tempId}/edit`);
    window.open(`${process.env.REACT_APP_DESIGN_EDITOR}/edit/template/${_id}/${tempId}`, '_blank');
  }

  return (
    <Container fluid className="main-content-container px-4">
      {/* Page Header */}
      {sendUpdate === 2 && (<span className="alertSuccess">Update Successful</span>)}
      {sendUpdate === -1 && (<span className="alertDanger">Update Failed!</span>)}
      <Row noGutters className="page-header py-4">
        <PageTitle sm="4" title="Edit Template" subtitle="Templates" className="text-sm-left" />
      </Row>
      <Tabs defaultActiveKey="details" id="uncontrolled-tab-example" onSelect={(eventKey) => setActiveTab(eventKey)}>
        <Tab eventKey="details" title="Details">
          <form className={loading === 'loading' ? 'blur' : ""} onSubmit={formik.handleSubmit}>
            <Row>
              <Col lg="4" md="2" className="previewHolder">
                <div>
                  <span>{`Temp No.: ${_.get(template, 'tempId', '-')}`}</span>
                  <img src={authResourceUrl(`${process.env.REACT_APP_FILE_SERVER}/resources/templates/${template._id}/thumbnail.png`, authToken)} className="editTemplatePreview" />
                  <span>{`${_.get(template, 'size.width', '-')} x ${_.get(template, 'size.height', '-')}`}</span>
                </div>
              </Col>
              <Col>
                <Row>
                  <Col>
                    <span>Name:</span>
                    <input id="templateName" name="name" required value={formik.values.name || ''} onChange={formik.handleChange} />
                  </Col>
                  <Col>
                    <span>Category:</span>
                    <select id="size" name="size" value={templateCategory} onChange={(e) => setTemplateCategory(e.currentTarget.value)}>
                      <option value="" hidden>---</option>
                      {allowedCategories.map(option =>
                        <option key={option.id} value={`${option.name}`}>{`${option.name} (${option.size})`}</option>
                      )}
                    </select>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <span>Owner:</span>
                    <input id="tempId" name="tempId" value={template.group || ''} disabled />
                  </Col>
                  <Col>
                    <span>Value:</span>
                    <select id="price" name="price" value={formik.values.price || '0'} onChange={formik.handleChange} >
                      <option value="0">Free</option>
                      <option value="1">Premium</option>
                    </select>
                  </Col>
                  <CheckPermission resource="template" action={["update"]} allowed="invisible">
                    <Col>
                      <span>Status:</span>
                      <select className={formik.values.invisible === 'true' ? 'danger' : ""} id="invisible" name="invisible" value={formik.values.invisible || 'false'} onChange={formik.handleChange}>
                        <option value="false">Publish</option>
                        <option value="true">Not Publish</option>
                      </select>
                    </Col>
                  </CheckPermission>
                </Row>
                <Row>
                  <Col>
                    <span>Description:</span>
                    <input id="description" name="description" value={formik.values.description || ''} onChange={formik.handleChange} />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <span>Tags (En):</span>
                    <textarea id="tags" name="tags" value={formik.values.tags} onChange={formik.handleChange} />
                  </Col>
                  <Col>
                    <span>Tags (Fa):</span>
                    <textarea id="tagsFa" name="tagsFa" value={formik.values.tagsFa} onChange={formik.handleChange} />
                  </Col>
                </Row>
                <Row noGutters className="buttonHolder">
                  <Col>
                    <Button type="submit" className="" variant="success"><i className="material-icons"></i> Update</Button>
                    {_.has(template, 'tempId') && (
                      <Button className="tableTempAction" onClick={() => designHandler(template._id, template.tempId)}><i className="material-icons"></i> Design</Button>
                    )}
                    <Button className="" variant="danger" onClick={() => window.close()}><i className="material-icons"></i> Cancel</Button>
                    {/* <Button className="" variant="danger" onClick={() => history.push(`/templates-list`)}><i className="material-icons"></i> Cancel</Button> */}
                  </Col>
                </Row>
              </Col>
            </Row>
          </form>
        </Tab>
        <Tab eventKey="resources" title="Resources">
          {/* <form onSubmit={uploadFormik.handleSubmit}>
            <input
              // id="invisible"
              name="invisible"
              value={uploadFormik.values.invisible} onChange={uploadFormik.handleChange}
            />
            <div {...getRootProps({ className: 'dropzone' })}>
              <input {...getInputProps()} />
              <p>Drag 'n' drop some files here, or click to select files</p>
            </div>
            <Button type="submit">Upload</Button>
            <aside className="thumbsContainer">
              {thumbs}
            </aside>
          </form> */}
          {group !== 'vibino' ? (
            <form ref={uploadFormRef} onSubmit={uploadFormHandle}>
              <div noGutters className="uploadButtonHolder">
                <Button
                  fluid
                  className="vButton colorPrimary "
                  // content={t('uploadPictureVideo')}
                  onClick={() => fileInputRef.current.click()}
                >Add File...</Button>
                <Button className="" variant="danger" onClick={() => history.push(`/templates-list`)}><i className="material-icons"></i> Cancel</Button>
                <input hidden name="invisible" value="true" />
                <input hidden name="tempId" value={template.tempId} />
                <input hidden name="group" value={group} />
              </div>
              <input
                ref={fileInputRef}
                type="file"
                name="files"
                accept="image/jpeg,image/png,image/svg+xml,video/mp4,video/quicktime,image/gif"
                hidden
                onChange={fileChange}
              />
            </form>
          ) : (
            <>
              <div id="hBtnHolder" className="hBtnHolder"></div>
              <AddResource uploadBtn="hBtnHolder" tempId={template.tempId} templateId={_templateId } lite />
            </>
          )}
          <div className={`thumbsBox ${resourceLoading === true && 'blur'}`}>
            <span>Images</span>
            {tempImages.map(thumb => <div id={thumb.data.id} key={thumb.data.id}  className='thumbsBoxHolder'><i onClick={() => setDeleteID({type:thumb.type, id:thumb.data.id, alias:thumb.data.alias})} className="material-icons deleteIcon">&#xe92b;</i><div className='thumbHolder'><img title={thumb.data.alias} className="thumb" src={authResourceUrl(thumb.src, authToken)} /></div><span>{thumb.data.alias}</span></div>)}
            <hr />
            <span>Videos</span>
            {tempVideos.map(thumb => <div id={thumb.data.id} key={thumb.data.id}  className='thumbsBoxHolder'><i onClick={() => setDeleteID({type:thumb.type, id:thumb.data.id, alias:thumb.data.alias})} className="material-icons deleteIcon">&#xe92b;</i><div className='thumbHolder'><img title={thumb.data.alias} className="thumb" src={authResourceUrl(thumb.src, authToken)} /></div><span>{thumb.data.alias}</span></div>)}
            {group === 'vibino' &&
              <>
                <hr />
                <span>Elements</span>
                {tempElements.map(thumb => <div id={thumb.data.id} key={thumb.data.id} className='thumbsBoxHolder'><i onClick={() => setDeleteID({type:thumb.type, id:thumb.data.id, alias:thumb.data.alias})} className="material-icons deleteIcon">&#xe92b;</i><div className='thumbHolder'><img title={thumb.data.alias} className="thumb" src={authResourceUrl(thumb.src, authToken)} /></div><span>{thumb.data.alias}</span></div>)}
              </>
            }            
          </div>
          {deleteID &&
            <div className="vModal">
              <div className="vModalContent">
                  <div className="vModalHeader">Please Confirm</div>
                  <div className="vModalBody">Do you want to delete "<b>{deleteID.alias}</b>"?<br />Please notice this action can not be undo.</div>
                  <div className="vModalFooter">
                      <Button className="dangerBtn" theme="primary" onClick={() => deleteHandler(deleteID)}><i className="material-icons"></i> Delete</Button>
                      <Button className="" theme="danger" onClick={() => setDeleteID(null)}><i className="material-icons"></i> Cancel</Button>
                  </div>
              </div>
            </div>
          }
          {deleteSuccess &&
            <div className="vModal">
              <div className="vModalContent">
                  <div className="vModalBody">{deleteSuccess}</div>
                  <div className="vModalFooter">
                      <Button className="" theme="danger" onClick={() => setDeleteSuccess(null)}><i className="material-icons"></i> Close</Button>
                  </div>
              </div>
            </div>
          }
        </Tab>
      </Tabs>

    </Container>
  );
}

export default TemplateEdit;
